import React, { useEffect, useState } from 'react';

import styled from '@emotion/styled';

import BreadCrumbs from '../../../components/BreadCrumbs/BreadCrumbs';
import PageHeader from '../../../components/Layout/PageHeader';
import PageLayout from '../../../components/Layout/PageLayout';
import Page from '../../../components/Page/Page';
import {
  DRIVER_SETUP,
  SINGLE_DRIVER_SETUP,
} from '../../../routes/routeConstants';
import SingleDriverSetupForm from './SingleDriverSetupForm';

const SingleDriverSetup = () => {
  const [pathArr, setPathArr] = useState<Record<string, string>[]>([]);

  useEffect(() => {
    setPathArr(() => [
      {
        name: `Driver Setup`,
        link: `/${DRIVER_SETUP}`,
      },
      {
        name: `New Entry`,
        link: `/${SINGLE_DRIVER_SETUP}`,
      },
    ]);
    // eslint-disable-next-line
  }, []);

  return (
    <Page title='Logirate | Single Driver Setup'>
      <PageLayout>
        <BreadCrumbs pathData={pathArr as any} />
        <Container>
          <PageHeader
            title='Set up a Driver Account'
            description='Generate a unique identifier for your driver.'
          />
          <SingleDriverSetupForm />
        </Container>
      </PageLayout>
    </Page>
  );
};

export default SingleDriverSetup;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
